import { render } from "./LoginModularHeader.vue?vue&type=template&id=8dd84c46&scoped=true"
import script from "./LoginModularHeader.vue?vue&type=script&lang=js"
export * from "./LoginModularHeader.vue?vue&type=script&lang=js"

import "./LoginModularHeader.vue?vue&type=style&index=0&id=8dd84c46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8dd84c46"

export default script